var map = {
	"./alterdata/aa.jpg": 2577,
	"./alterdata/img-1.jpg": 9962,
	"./alterdata/img-2.jpg": 8434,
	"./alterdata/img-3.jpg": 9276,
	"./alterdata/img-4.jpg": 8987,
	"./alterdata/img-5.jpg": 6343,
	"./alterdata/img-6.jpg": 5463,
	"./alterdata/img-7.jpg": 4198,
	"./homer/img-1.jpg": 7157,
	"./homer/img-10.jpg": 2141,
	"./homer/img-12.jpg": 2349,
	"./homer/img-2.png": 693,
	"./homer/img-3.jpg": 9609,
	"./homer/img-4.jpg": 3494,
	"./homer/img-5.jpg": 5243,
	"./homer/img-6.jpg": 2177,
	"./homer/img-7.png": 6771,
	"./homer/img-8.jpg": 4837,
	"./homer/img-9.png": 6810,
	"./homer/img-time.jpg": 489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5234;